import React from 'react';
import PageContainer from '../../components/PageContainer';
import GeminiApp from '../../geminiTest/App';

const AiTestPage = () => {
  return (
    <PageContainer contentStyle={{ padding: 0 }}>
      <div style={{ width: '100%', maxHeight: 'calc(100vh - 100px)', borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden', padding: 0, overflowY: 'scroll' }}>
        <GeminiApp />
      </div>
    </PageContainer>
  );
};

export default AiTestPage;
